import {
    CERTIFICATES_GENERATE_TOKEN_RESULT,
    CERTIFICATES_DOWNLOAD_RESULT,
    CERTIFICATES_SET_LOADING
} from './actionTypes';

const INIT_STATE = {
    loading: false,
    token: null,
    error: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CERTIFICATES_SET_LOADING:
            return { ...state, loading: action.payload };

        case CERTIFICATES_GENERATE_TOKEN_RESULT:
            return { ...state, token: action.payload, loading: false };

        case CERTIFICATES_DOWNLOAD_RESULT:
            return { ...state, loading: false };

        default:
            return state;
    }
};